import classNames from 'classnames';
import PropTypes from 'prop-types';
import styles from './GridRow.module.scss';

const GridRow = ({
  children,
  row = true,
  column = false,
  reverse = false,
  className = undefined,
  ...props
}) => {
  const classes = {
    [styles.row]: row,
    [styles['row--reverse']]: row && reverse && !column,
    [styles.column]: column && !row && !reverse,
    [styles['row--reverse']]: row && reverse,
  };

  return (
    <div
      data-testid="component-grid-row"
      className={classNames([`${styles.row}`, classes, className])}
      {...props}
    >
      {children}
    </div>
  );
};

GridRow.propTypes = {
  className: PropTypes.string,
  row: PropTypes.bool,
  column: PropTypes.bool,
  reverse: PropTypes.bool,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
};

export default GridRow;
